<template>
  <div class="hero-foot pm-foot py-4">
    <nav class="tabs">
      <div class="container">
        <div class="columns">
          <div class="column is-9">
            <div class="footer-logo mt-3 has-text-centered-mobile">
              <img src="../assets/img/logo.svg">
            </div>
            <div class="columns is-multiline has-text-centered-mobile">
              <div class="column is-3">
                <ul class="footer-menu">
                  <li>{{ this.$t("message.components.footer.customerSupport") }}</li>
                  <li @click="$router.push({name: 'AboutUs'})" class="font-12">{{ this.$t("message.components.footer.contact") }}</li>
                  <li @click="$router.push({name: 'FaqPage'})" class="font-12">{{ this.$t("message.components.footer.faq") }}</li>
                  <li @click="$router.push({name: 'TipsPage'})" class="font-12">Vinkkejä kuppien suunnitteluun</li>
                </ul>
              </div>
              <div class="column is-3">
                <ul class="footer-menu">
                  <li>{{ this.$t("message.components.footer.rules") }}</li>
                  <li @click="$router.push({name: 'PrivacyPolicyPage'})" class="font-12">{{ this.$t("message.components.footer.privacyPolicy") }}</li>
                  <li @click="$router.push({name: 'TermsPage'})" class="font-12">{{ this.$t("message.components.footer.shipmentPoliy") }}</li>
                </ul>
              </div>
              <div class="column is-3">
                <ul class="footer-menu">
                  <li>{{ this.$t("message.components.footer.aboutUs") }}</li>
                  <li class="font-12" @click="openPyrollSite">Pyroll</li>
                </ul>
              </div>
              <div class="column is-3">
                <p class="font-12" style="margin-top: 7px;">Pyroll Kuitupakkaukset Oy</p>
                <p class="font-12" style="margin-top: 7px;">Valtatie 12</p>
                <p class="font-12" style="margin-top: 7px;">46900 Inkeroinen</p>
                <p class="font-12" style="margin-top: 7px;">puh. 05 747 2200</p>
                <p class="font-12" style="margin-top: 7px;">asiakaspalvelu@packagemedia.fi</p>
              </div>
              <div class="column is-12 mt-6">
                <p class="copyright font-12">{{ this.$t("message.components.footer.copyright") }}</p>
              </div>
            </div>
          </div>
          <div class="column is-offset-2 is-1 icons">
            <ul>
              <li><img style="max-height: 100px; margin-right: 30px;" src="../assets/img/paytrail.jpg"/></li>
              <li><img style="max-height: 100px; margin-right: 30px;" src="../assets/img/Avainlippu_tehty_Suomessa.jpeg"/></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <PrivacyPolicy ref="privacyModal"/>
</template>

<script>
import PrivacyPolicy from '../modals/PrivacyPolicy'

export default {
  name: "PmFooter",
  components: {
    PrivacyPolicy,
  },
  data() {
    return {};
  },
  methods: {
    customOpenModal() {
      window.scrollTo(0, 0);
      this.$refs.privacyModal.showModal();
    },
    openPyrollSite() {
      window.open('https://www.pyroll.com/', '_blank', 'noopener')
    }
  },
  mounted() {},
  computed: {},
};
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.pm-foot {
  background-color: $pyroll-grey;
  color: black;
  .icons {
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
    ul {
      flex-grow: 1;
      flex-shrink: 0;
      justify-content: flex-start;
    }
  }
  .footer-logo {
    img {
      height: 50px;
    }
  }
  .footer-menu {
    display: block;
    li {
      color: $pyroll-black2;
      margin-top: 7px;
    }
    li:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .copyright {
    color: $pyroll-grey2;
  }
}
</style>
